import {
  useMutation,
  useQuery
} from '@tanstack/vue-query'
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationReturnType,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query'
import {
  unref
} from 'vue'
import type {
  MaybeRef
} from 'vue'
import type {
  ApiGetValueAddedServicesAsAdminParams,
  ApiGetValueAddedServicesParams,
  BackendErrorEntity,
  ComputeLogisticServicePriceQueryDto,
  ComputeLogisticServicePriceResponseDto,
  CustomerValueAddedServiceDto,
  GetPowertrainWarrantyDurationsResponseDto,
  SubmitLogisticServiceRequestBodyDto,
  SubmitLogisticServiceRequestResponseDto,
  ValueAddedServiceDto
} from '.././types'
import { fetchApiInstance } from '../../fetchApiInstance';
import type { ErrorType, BodyType } from '../../fetchApiInstance';


type SecondParameter<T extends (...args: any) => any> = Parameters<T>[1];


export const apiGetValueAddedServices = (
    params?: MaybeRef<ApiGetValueAddedServicesParams>,
 options?: SecondParameter<typeof fetchApiInstance>,) => {
      params = unref(params);
      
      return fetchApiInstance<CustomerValueAddedServiceDto[]>(
      {url: `/valueAddedServices`, method: 'GET',
        params: unref(params)
    },
      options);
    }
  

export const getApiGetValueAddedServicesQueryKey = (params?: MaybeRef<ApiGetValueAddedServicesParams>,) => {
    return ['valueAddedServices', ...(params ? [params]: [])] as const;
    }

    
export const getApiGetValueAddedServicesQueryOptions = <TData = Awaited<ReturnType<typeof apiGetValueAddedServices>>, TError = ErrorType<BackendErrorEntity>>(params?: MaybeRef<ApiGetValueAddedServicesParams>, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof apiGetValueAddedServices>>, TError, TData>, request?: SecondParameter<typeof fetchApiInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getApiGetValueAddedServicesQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiGetValueAddedServices>>> = () => apiGetValueAddedServices(params, requestOptions);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof apiGetValueAddedServices>>, TError, TData> 
}

export type ApiGetValueAddedServicesQueryResult = NonNullable<Awaited<ReturnType<typeof apiGetValueAddedServices>>>
export type ApiGetValueAddedServicesQueryError = ErrorType<BackendErrorEntity>



export function useApiGetValueAddedServices<TData = Awaited<ReturnType<typeof apiGetValueAddedServices>>, TError = ErrorType<BackendErrorEntity>>(
 params?: MaybeRef<ApiGetValueAddedServicesParams>, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof apiGetValueAddedServices>>, TError, TData>, request?: SecondParameter<typeof fetchApiInstance>}

  ): UseQueryReturnType<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getApiGetValueAddedServicesQueryOptions(params,options)

  const query = useQuery(queryOptions) as UseQueryReturnType<TData, TError> & { queryKey: QueryKey };

  query.queryKey = unref(queryOptions).queryKey as QueryKey;

  return query;
}



export const apiGetValueAddedServicesAsAdmin = (
    params: MaybeRef<ApiGetValueAddedServicesAsAdminParams>,
 options?: SecondParameter<typeof fetchApiInstance>,) => {
      params = unref(params);
      
      return fetchApiInstance<ValueAddedServiceDto[]>(
      {url: `/valueAddedServices/asAdmin`, method: 'GET',
        params: unref(params)
    },
      options);
    }
  

export const getApiGetValueAddedServicesAsAdminQueryKey = (params: MaybeRef<ApiGetValueAddedServicesAsAdminParams>,) => {
    return ['valueAddedServices','asAdmin', ...(params ? [params]: [])] as const;
    }

    
export const getApiGetValueAddedServicesAsAdminQueryOptions = <TData = Awaited<ReturnType<typeof apiGetValueAddedServicesAsAdmin>>, TError = ErrorType<BackendErrorEntity>>(params: MaybeRef<ApiGetValueAddedServicesAsAdminParams>, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof apiGetValueAddedServicesAsAdmin>>, TError, TData>, request?: SecondParameter<typeof fetchApiInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getApiGetValueAddedServicesAsAdminQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiGetValueAddedServicesAsAdmin>>> = () => apiGetValueAddedServicesAsAdmin(params, requestOptions);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof apiGetValueAddedServicesAsAdmin>>, TError, TData> 
}

export type ApiGetValueAddedServicesAsAdminQueryResult = NonNullable<Awaited<ReturnType<typeof apiGetValueAddedServicesAsAdmin>>>
export type ApiGetValueAddedServicesAsAdminQueryError = ErrorType<BackendErrorEntity>



export function useApiGetValueAddedServicesAsAdmin<TData = Awaited<ReturnType<typeof apiGetValueAddedServicesAsAdmin>>, TError = ErrorType<BackendErrorEntity>>(
 params: MaybeRef<ApiGetValueAddedServicesAsAdminParams>, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof apiGetValueAddedServicesAsAdmin>>, TError, TData>, request?: SecondParameter<typeof fetchApiInstance>}

  ): UseQueryReturnType<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getApiGetValueAddedServicesAsAdminQueryOptions(params,options)

  const query = useQuery(queryOptions) as UseQueryReturnType<TData, TError> & { queryKey: QueryKey };

  query.queryKey = unref(queryOptions).queryKey as QueryKey;

  return query;
}



export const apiComputeLogisticServicePrice = (
    computeLogisticServicePriceQueryDto: MaybeRef<ComputeLogisticServicePriceQueryDto>,
 options?: SecondParameter<typeof fetchApiInstance>,) => {
      computeLogisticServicePriceQueryDto = unref(computeLogisticServicePriceQueryDto);
      
      return fetchApiInstance<ComputeLogisticServicePriceResponseDto>(
      {url: `/valueAddedServices/computeLogisticServicePrice`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: computeLogisticServicePriceQueryDto
    },
      options);
    }
  


export const getApiComputeLogisticServicePriceMutationOptions = <TError = ErrorType<BackendErrorEntity>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiComputeLogisticServicePrice>>, TError,{data: BodyType<ComputeLogisticServicePriceQueryDto>}, TContext>, request?: SecondParameter<typeof fetchApiInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof apiComputeLogisticServicePrice>>, TError,{data: BodyType<ComputeLogisticServicePriceQueryDto>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiComputeLogisticServicePrice>>, {data: BodyType<ComputeLogisticServicePriceQueryDto>}> = (props) => {
          const {data} = props ?? {};

          return  apiComputeLogisticServicePrice(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ApiComputeLogisticServicePriceMutationResult = NonNullable<Awaited<ReturnType<typeof apiComputeLogisticServicePrice>>>
    export type ApiComputeLogisticServicePriceMutationBody = BodyType<ComputeLogisticServicePriceQueryDto>
    export type ApiComputeLogisticServicePriceMutationError = ErrorType<BackendErrorEntity>

    export const useApiComputeLogisticServicePrice = <TError = ErrorType<BackendErrorEntity>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiComputeLogisticServicePrice>>, TError,{data: BodyType<ComputeLogisticServicePriceQueryDto>}, TContext>, request?: SecondParameter<typeof fetchApiInstance>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof apiComputeLogisticServicePrice>>,
        TError,
        {data: BodyType<ComputeLogisticServicePriceQueryDto>},
        TContext
      > => {

      const mutationOptions = getApiComputeLogisticServicePriceMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const apiComputeLogisticServicePriceAsAdmin = (
    computeLogisticServicePriceQueryDto: MaybeRef<ComputeLogisticServicePriceQueryDto>,
 options?: SecondParameter<typeof fetchApiInstance>,) => {
      computeLogisticServicePriceQueryDto = unref(computeLogisticServicePriceQueryDto);
      
      return fetchApiInstance<ComputeLogisticServicePriceResponseDto>(
      {url: `/valueAddedServices/computeLogisticServicePriceAsAdmin`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: computeLogisticServicePriceQueryDto
    },
      options);
    }
  


export const getApiComputeLogisticServicePriceAsAdminMutationOptions = <TError = ErrorType<BackendErrorEntity>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiComputeLogisticServicePriceAsAdmin>>, TError,{data: BodyType<ComputeLogisticServicePriceQueryDto>}, TContext>, request?: SecondParameter<typeof fetchApiInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof apiComputeLogisticServicePriceAsAdmin>>, TError,{data: BodyType<ComputeLogisticServicePriceQueryDto>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiComputeLogisticServicePriceAsAdmin>>, {data: BodyType<ComputeLogisticServicePriceQueryDto>}> = (props) => {
          const {data} = props ?? {};

          return  apiComputeLogisticServicePriceAsAdmin(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ApiComputeLogisticServicePriceAsAdminMutationResult = NonNullable<Awaited<ReturnType<typeof apiComputeLogisticServicePriceAsAdmin>>>
    export type ApiComputeLogisticServicePriceAsAdminMutationBody = BodyType<ComputeLogisticServicePriceQueryDto>
    export type ApiComputeLogisticServicePriceAsAdminMutationError = ErrorType<BackendErrorEntity>

    export const useApiComputeLogisticServicePriceAsAdmin = <TError = ErrorType<BackendErrorEntity>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiComputeLogisticServicePriceAsAdmin>>, TError,{data: BodyType<ComputeLogisticServicePriceQueryDto>}, TContext>, request?: SecondParameter<typeof fetchApiInstance>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof apiComputeLogisticServicePriceAsAdmin>>,
        TError,
        {data: BodyType<ComputeLogisticServicePriceQueryDto>},
        TContext
      > => {

      const mutationOptions = getApiComputeLogisticServicePriceAsAdminMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Returns a list of enabled powertrain warranty configurations with duration, mileage limits, and prices. Results are sorted by duration in ascending order.
 * @summary Get available powertrain warranty duration options
 */
export const apiGetPowertrainWarrantyDurations = (
    
 options?: SecondParameter<typeof fetchApiInstance>,) => {
      
      
      return fetchApiInstance<GetPowertrainWarrantyDurationsResponseDto>(
      {url: `/valueAddedServices/powertrainWarranty/durations`, method: 'GET'
    },
      options);
    }
  

export const getApiGetPowertrainWarrantyDurationsQueryKey = () => {
    return ['valueAddedServices','powertrainWarranty','durations'] as const;
    }

    
export const getApiGetPowertrainWarrantyDurationsQueryOptions = <TData = Awaited<ReturnType<typeof apiGetPowertrainWarrantyDurations>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof apiGetPowertrainWarrantyDurations>>, TError, TData>, request?: SecondParameter<typeof fetchApiInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getApiGetPowertrainWarrantyDurationsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiGetPowertrainWarrantyDurations>>> = () => apiGetPowertrainWarrantyDurations(requestOptions);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof apiGetPowertrainWarrantyDurations>>, TError, TData> 
}

export type ApiGetPowertrainWarrantyDurationsQueryResult = NonNullable<Awaited<ReturnType<typeof apiGetPowertrainWarrantyDurations>>>
export type ApiGetPowertrainWarrantyDurationsQueryError = ErrorType<unknown>


/**
 * @summary Get available powertrain warranty duration options
 */

export function useApiGetPowertrainWarrantyDurations<TData = Awaited<ReturnType<typeof apiGetPowertrainWarrantyDurations>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof apiGetPowertrainWarrantyDurations>>, TError, TData>, request?: SecondParameter<typeof fetchApiInstance>}

  ): UseQueryReturnType<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getApiGetPowertrainWarrantyDurationsQueryOptions(options)

  const query = useQuery(queryOptions) as UseQueryReturnType<TData, TError> & { queryKey: QueryKey };

  query.queryKey = unref(queryOptions).queryKey as QueryKey;

  return query;
}



/**
 * Returns a list of enabled powertrain warranty configurations with duration, mileage limits, and prices. Results are sorted by duration in ascending order.
 * @summary Get available powertrain warranty duration options as admin
 */
export const apiGetPowertrainWarrantyDurationsAsAdmin = (
    
 options?: SecondParameter<typeof fetchApiInstance>,) => {
      
      
      return fetchApiInstance<GetPowertrainWarrantyDurationsResponseDto>(
      {url: `/valueAddedServices/powertrainWarranty/durationsAsAdmin`, method: 'GET'
    },
      options);
    }
  

export const getApiGetPowertrainWarrantyDurationsAsAdminQueryKey = () => {
    return ['valueAddedServices','powertrainWarranty','durationsAsAdmin'] as const;
    }

    
export const getApiGetPowertrainWarrantyDurationsAsAdminQueryOptions = <TData = Awaited<ReturnType<typeof apiGetPowertrainWarrantyDurationsAsAdmin>>, TError = ErrorType<BackendErrorEntity>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof apiGetPowertrainWarrantyDurationsAsAdmin>>, TError, TData>, request?: SecondParameter<typeof fetchApiInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getApiGetPowertrainWarrantyDurationsAsAdminQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiGetPowertrainWarrantyDurationsAsAdmin>>> = () => apiGetPowertrainWarrantyDurationsAsAdmin(requestOptions);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof apiGetPowertrainWarrantyDurationsAsAdmin>>, TError, TData> 
}

export type ApiGetPowertrainWarrantyDurationsAsAdminQueryResult = NonNullable<Awaited<ReturnType<typeof apiGetPowertrainWarrantyDurationsAsAdmin>>>
export type ApiGetPowertrainWarrantyDurationsAsAdminQueryError = ErrorType<BackendErrorEntity>


/**
 * @summary Get available powertrain warranty duration options as admin
 */

export function useApiGetPowertrainWarrantyDurationsAsAdmin<TData = Awaited<ReturnType<typeof apiGetPowertrainWarrantyDurationsAsAdmin>>, TError = ErrorType<BackendErrorEntity>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof apiGetPowertrainWarrantyDurationsAsAdmin>>, TError, TData>, request?: SecondParameter<typeof fetchApiInstance>}

  ): UseQueryReturnType<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getApiGetPowertrainWarrantyDurationsAsAdminQueryOptions(options)

  const query = useQuery(queryOptions) as UseQueryReturnType<TData, TError> & { queryKey: QueryKey };

  query.queryKey = unref(queryOptions).queryKey as QueryKey;

  return query;
}



export const apiSubmitLogisticServiceRequest = (
    submitLogisticServiceRequestBodyDto: MaybeRef<SubmitLogisticServiceRequestBodyDto>,
 options?: SecondParameter<typeof fetchApiInstance>,) => {
      submitLogisticServiceRequestBodyDto = unref(submitLogisticServiceRequestBodyDto);
      
      return fetchApiInstance<SubmitLogisticServiceRequestResponseDto>(
      {url: `/valueAddedServices/submitLogisticServiceRequest`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: submitLogisticServiceRequestBodyDto
    },
      options);
    }
  


export const getApiSubmitLogisticServiceRequestMutationOptions = <TError = ErrorType<BackendErrorEntity>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiSubmitLogisticServiceRequest>>, TError,{data: BodyType<SubmitLogisticServiceRequestBodyDto>}, TContext>, request?: SecondParameter<typeof fetchApiInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof apiSubmitLogisticServiceRequest>>, TError,{data: BodyType<SubmitLogisticServiceRequestBodyDto>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiSubmitLogisticServiceRequest>>, {data: BodyType<SubmitLogisticServiceRequestBodyDto>}> = (props) => {
          const {data} = props ?? {};

          return  apiSubmitLogisticServiceRequest(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ApiSubmitLogisticServiceRequestMutationResult = NonNullable<Awaited<ReturnType<typeof apiSubmitLogisticServiceRequest>>>
    export type ApiSubmitLogisticServiceRequestMutationBody = BodyType<SubmitLogisticServiceRequestBodyDto>
    export type ApiSubmitLogisticServiceRequestMutationError = ErrorType<BackendErrorEntity>

    export const useApiSubmitLogisticServiceRequest = <TError = ErrorType<BackendErrorEntity>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiSubmitLogisticServiceRequest>>, TError,{data: BodyType<SubmitLogisticServiceRequestBodyDto>}, TContext>, request?: SecondParameter<typeof fetchApiInstance>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof apiSubmitLogisticServiceRequest>>,
        TError,
        {data: BodyType<SubmitLogisticServiceRequestBodyDto>},
        TContext
      > => {

      const mutationOptions = getApiSubmitLogisticServiceRequestMutationOptions(options);

      return useMutation(mutationOptions);
    }
    